import React from 'react';
import PropTypes from 'prop-types';
import SkuNotice from '../AddSkuNotice';
import AddSkuMessage from '../AddSkuMessage';
import styles from './styles.scss';

class AddTopSkuNotice extends React.Component {
  static propTypes = {
    bullets: PropTypes.shape({
      size: PropTypes.number,
    }).isRequired,
  };

  state = { visible: false };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.body.style.overflow = 'visible';
  }

  handleResize = () => {
    if (window.innerWidth > 1200) {
      this.setState({ visible: false });
      document.body.style.overflow = 'visible';
    }
  };

  handleClick = () => {
    this.setState({ visible: !this.state.visible }, () => {
      document.body.style.overflow = this.state.visible ? 'hidden' : 'visible';
    });
  };

  render() {
    const { bullets } = this.props;
    const { visible } = this.state;
    if (!bullets.size) return null;

    return (
      <div className={styles.container}>
        {visible && <AddSkuMessage bullets={bullets} />}
        <SkuNotice handleClick={this.handleClick} visible={visible} />
        {visible && (
          <button
            type="button"
            role="presentation"
            onClick={this.handleClick}
            className={styles.dimLayer}
          />
        )}
      </div>
    );
  }
}

export default AddTopSkuNotice;
